<template>
  <div class="container mobile-container-small">
    <div class="kontakty-wrapper">
      <div class="cms-block-stub">
        <h1>Контакты</h1>
      </div>
      <p>
        Телефон контактного центра {{ ' ' }} <a :href="`tel:+${cleanedPhone}`">+{{ phoneFormat(phone) }}</a>. Звонок по
        России бесплатный.
      </p>
      <ul
        v-if="stores.length > 0"
        class="kontakty-branches"
      >
        <li
          v-for="branch in stores"
          :key="`${branch.city}, ${branch.address}`"
          class="kontakty-branch"
        >
          <p class="kontakty-branch-address">
            <strong>г. {{ branch.city }},</strong> {{ ' ' }} {{ branch.address }}
          </p>
          <p>{{ branch.schedule }}</p>
          <div class="kontakty-branch-socials">
            <a
              v-if="branch.whatsAppLink"
              class="kontakty-branch-social"
              target="_blank"
              :href="branch.whatsAppLink"
            >
              <img
                :src="WAIcon"
                alt="whatsapp icon"
              >
              <span>
                WhatsApp
              </span>
            </a>
            <a
              v-if="branch.viberLink"
              class="kontakty-branch-social"
              target="_blank"
              :href="branch.viberLink"
            >
              <img
                :src="ViberIcon"
                alt="viber icon"
              >
              <span>
                Viber
              </span>
            </a>
          </div>
          <div>
            <client-only>
              <YandexMap
                class="kontakty-map"
                :coordinates="[branch.lat, branch.lon]"
                :zoom="15"
              >
                <YandexMarker
                  :coordinates="[branch.lat, branch.lon]"
                  :marker-id="`kontakty-ymap-marker-${branch.id}`"
                  :properties="{
                    'iconCaption': 'cilek-kids.ru'
                  }"
                >
                  <template #component>
                    <div class="kontakty-map-balloon">{{ branch.address }}</div>
                  </template>
                </YandexMarker>
              </YandexMap>
            </client-only>
          </div>
        </li>
      </ul>

      <div class="kontakty-wrapper__details-legal">
        <h2>Реквизиты</h2>
        <p>ИП Мушкетова Ирина Сергеевна</p>
        <p>ИНН: 667003335651</p>
        <p>ОГРНИП: 323665800011840</p>
        <p>Р/с: 40802810220000093275</p>
        <p>в ООО "Банк Точка" г. Москва</p>
        <p>БИК: 044525104</p>
        <p>к/с: 30101810745374525104</p>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { phoneFormat } from '~/helpers/formatters';
import ViberIcon from 'assets/img/png/kontakty/vb.png';
import WAIcon from 'assets/img/png/kontakty/wa.png';
import {
  appConfigStore as useAppConfigStore
} from '#sitis/stores/modules/app-store';
import { YandexMap, YandexMarker } from 'vue-yandex-maps';
import type {ComputedRef} from "vue";

const {
  $api
} = useNuxtApp();
const appConfig = useAppConfigStore();

const {
  getCMSContent
} = useSitisCMSPage();
await useLazyAsyncData("get-stores-cms-contenr", getCMSContent);

const getStores = async () => {
  const _res = await $api.agent.get('/stores').then((res: any) => {
    return res?._data || []
  }).catch(() => {
    return []
  });
  const _resStores = await $api.agent.get('/stores/cities?expand=city').then((res: any) => {
    return res?._data || []
  }).catch(() => {
    return []
  });

  const _stores = _res
    .map((item: any) => {
    const _resStore: any = _resStores.find((_item: any) => _item.id === item.city_id);
    const viberLink = ((_resStore?.cms_data || []).find((t: any) => Boolean(t.var === 'Viber'))?.value || '').replace(/\D+/g, '');
    const whatsAppLink = ((_resStore?.cms_data || []).find((t: any) => Boolean(t.var === 'Whatsapp'))?.value || '').replace(/\D+/g, '');

    return {
      id: item.id,
      city: item.city_name,
      address: item.address,
      schedule: item.working_hours,
      viberLink: Boolean(viberLink) ? `viber://add?number=${viberLink}` : '',
      whatsAppLink: Boolean(whatsAppLink) ? `https://api.whatsapp.com/send?phone=${whatsAppLink}` : '',
      lat: item.lat,
      lon: item.lon,
      fullStore: _resStore
    }
  })
    .filter((t: any) => Boolean(t?.fullStore?.city_id !== 498817))
  return _stores
};
const { data: storesList } = await useLazyAsyncData("get-stores", getStores);
const stores: ComputedRef<any[]> = computed(() => {
  // нормальная логика подклчюения магазинов
  // return storesList.value || []
  // далее следует костыль по пожеланиям мии
  return storesList.value.filter((t: any) => t.id === 2).map((item: any) => {
      return {
        ...item,
        address: "105187, г. Москва, Вольная улица, 28/4к1, вход 2Н",
      }
    }
  )
})

const phone: ComputedRef<string> = computed(() => {
  return appConfig.$state?.vars?.Телефон || ""
});
const cleanedPhone = computed(() => {
  if (!phone.value) {
    return ""
  }
  return phoneFormat(phone.value, true)
});
</script>

<style lang="scss">
.kontakty-branches {
  margin: 16px 0 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
  list-style: none;
  padding: 0;
}

.kontakty-branch {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.kontakty-branch-address {
}

.kontakty-branch-socials {
  display: flex;
  align-items: center;
  gap: 20px;
}

.kontakty-branch-social {
  display: flex;
  align-items: center;
  gap: 5px;

  > span {
    font-size: 16px;
    line-height: normal;
  }

  > img {
    width: 20px;
    height: 20px;
  }
}

.kontakty-map {
  width: 100%;
  height: 400px;

  .yandex-balloon {
    width: 200px;
    height: 50px;
  }
}

.kontakty-map-balloon {
  font-size: 14px;
}

.kontakty-wrapper__details-legal {
  padding-top: 40px;
}
</style>
